module.exports = __webpack_public_path__ + "static/img/operateHuhui.171bf2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateHuhui.png
// module id = kySJ
// module chunks = 1